module.exports = __webpack_public_path__ + "static/img/Phil_Davis_mobile.7e63b49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Phil_Davis_mobile.jpg
// module id = +f8O
// module chunks = 0